import React from 'react';
import styled from 'styled-components';

import ToggleMapButton from './components/ToggleMapButton';
import ShowFiltersButton from './components/ShowFiltersButton';
import SubscribeButton from './components/SubscribeButton';

import { getFiltersCount } from './utils';
import type { IFloatingPanelMobile } from './types';

export const FloatingPanelMobile = (props: IFloatingPanelMobile) => {
  const {
    mapView,
    toggleFilters,
    toggleSubscribe,
    toggleMap,
    setVisibleHotelsLimit,
    isWhitelabel,
    isHotelOnly,
    isSubscribed = false,
    isMountainsActive = false,
    onCloseMountains,
  } = props;

  const filtersCount = getFiltersCount();

  const handleSubscribeToggle = () => {
    if (mapView) toggleMap();

    toggleSubscribe();

    if (isMountainsActive && onCloseMountains) {
      onCloseMountains();
    }
  };

  const handleFilterToggle = () => {
    if (mapView) toggleMap();
    toggleFilters();
  };

  const isSubscribeButtonVisible = !isWhitelabel && !isHotelOnly;

  return (
    <FloatingPanelWrapper>
      <BottomPanelWrapper>
        {isSubscribeButtonVisible && (
          <SubscribeButton
            isSubscribed={isSubscribed}
            toggleSubscribe={handleSubscribeToggle}
          />
        )}

        {isSubscribeButtonVisible && <Separator />}

        <ShowFiltersButton
          toggleFilters={handleFilterToggle}
          count={filtersCount}
          isFirstButton={!isSubscribeButtonVisible}
        />

        <Separator />

        <ToggleMapButton
          toggleHandler={toggleMap}
          setVisibleHotelsLimit={setVisibleHotelsLimit}
          mapView={mapView}
        />
      </BottomPanelWrapper>
    </FloatingPanelWrapper>
  );
};

const FloatingPanelWrapper = styled.div<{ $isPopupOnMapOpened?: boolean }>`
  position: relative;

  height: 50px;
  width: 100%;
  padding: 0 54px;

  pointer-events: none;
  button {
    pointer-events: all;
  }
`;

const BottomPanelWrapper = styled.div`
  display: flex;
  height: 100%;

  border-radius: var(--border-radius);
  background-color: var(--white);
  box-shadow: var(--box-shadow);
`;

const Separator = styled.div`
  margin: 8px 0;
  flex: 0 0 1px;
  background-color: var(--black);
  opacity: 0.08;
`;
